var _circle, _path, _rect, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailInCircleGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4 10.25H16.367C15.2749 10.25 14.4094 10.25 13.7117 10.307C12.9983 10.3653 12.3947 10.4869 11.8435 10.7677C10.9498 11.2231 10.2231 11.9498 9.76772 12.8435C9.48688 13.3947 9.36527 13.9983 9.30699 14.7117C9.24999 15.4094 9.24999 16.2749 9.25 17.367V17.367V17.4V20.6V20.633C9.24999 21.7251 9.24999 22.5906 9.30699 23.2883C9.36527 24.0017 9.48688 24.6053 9.76772 25.1565C10.2231 26.0502 10.9498 26.7769 11.8435 27.2323C12.3947 27.5131 12.9983 27.6347 13.7117 27.693C14.4094 27.75 15.2748 27.75 16.367 27.75H16.4H23.6H23.633C24.7252 27.75 25.5906 27.75 26.2883 27.693C27.0017 27.6347 27.6053 27.5131 28.1565 27.2323C29.0502 26.7769 29.7769 26.0502 30.2323 25.1565C30.5131 24.6053 30.6347 24.0017 30.693 23.2883C30.75 22.5906 30.75 21.7252 30.75 20.633V20.6V17.4V17.367C30.75 16.2748 30.75 15.4094 30.693 14.7117C30.6347 13.9983 30.5131 13.3947 30.2323 12.8435C29.7769 11.9498 29.0502 11.2231 28.1565 10.7677C27.6053 10.4869 27.0017 10.3653 26.2883 10.307C25.5906 10.25 24.7251 10.25 23.633 10.25H23.6H16.4ZM12.5245 12.1042C12.829 11.9491 13.2133 11.8527 13.8339 11.802C14.4633 11.7506 15.2675 11.75 16.4 11.75H23.6C24.7325 11.75 25.5367 11.7506 26.1661 11.802C26.7867 11.8527 27.171 11.9491 27.4755 12.1042C28.087 12.4158 28.5842 12.913 28.8958 13.5245C29.0509 13.829 29.1473 14.2133 29.198 14.8339C29.2494 15.4633 29.25 16.2675 29.25 17.4V20.6C29.25 21.7325 29.2494 22.5367 29.198 23.1661C29.1473 23.7867 29.0509 24.171 28.8958 24.4755C28.5842 25.087 28.087 25.5842 27.4755 25.8958C27.171 26.0509 26.7867 26.1473 26.1661 26.198C25.5367 26.2494 24.7325 26.25 23.6 26.25H16.4C15.2675 26.25 14.4633 26.2494 13.8339 26.198C13.2133 26.1473 12.829 26.0509 12.5245 25.8958C11.913 25.5842 11.4158 25.087 11.1042 24.4755C10.9491 24.171 10.8527 23.7867 10.802 23.1661C10.7506 22.5367 10.75 21.7325 10.75 20.6V17.4C10.75 16.2675 10.7506 15.4633 10.802 14.8339C10.8527 14.2133 10.9491 13.829 11.1042 13.5245C11.4158 12.913 11.913 12.4158 12.5245 12.1042ZM14.416 14.376C14.0714 14.1462 13.6057 14.2393 13.376 14.584C13.1462 14.9286 13.2393 15.3943 13.584 15.624L19.584 19.624C19.8359 19.792 20.1641 19.792 20.416 19.624L26.416 15.624C26.7607 15.3943 26.8538 14.9286 26.624 14.584C26.3943 14.2393 25.9286 14.1462 25.584 14.376L20 18.0986L14.416 14.376Z",
    fill: "#636F7E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 11,
    width: 20,
    height: 16,
    rx: 4,
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15L20 19L26 15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 14,
    y1: 28,
    x2: 38.7553,
    y2: 5.37343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EB3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BFFDA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailInCircleGradient);
export default ForwardRef;